<div *ngIf="statusMsg != '' && isVisible" [class]="className">
  <div class="notification-icon">
    <i class="fa fa-info notification-icon"></i>
  </div>
  <p style="margin: 0;">{{statusMsg}}</p>
  <a class="close-notification" (click)="isVisible = !isVisible" href="javascript:void(0)">
    <i class="fa fa-times"></i>
  </a>
</div>
